module.exports = __webpack_public_path__ + "img/semiRing4.3c5e5c05.svg";